import { laptopSmallMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 0 30px;

  h2 {
    color: ${({ theme }) => theme.textDark};
    font-size: 30px;
    margin-bottom: 30px;
  }

  @media (${laptopSmallMax}) {
    padding: 0 15px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  margin: 15px auto 0px;
  max-width: 1280px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 30px;
  grid-row-gap: 30px;

  @media (${laptopSmallMax}) {
    grid-column-gap: 15px;
    grid-template-columns: repeat(2, 1fr);
  }

  @media (${mobileXXLargeMax}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
